<template>
    <div class="home">
      <AssetTypeList v-show="listView" @newAsset="onClickNewFromList" @editAsset="onClickEditFromList" :scroll="corY" ref="refreshList" />
      <AssetTypeForm v-show="formView" :asset="asset" @backClicked="onBackChild" @onBack="onBack" backReload="backReload"/>
    </div>
</template>
<script>
import AssetTypeList from '@/components/finance/AssetTypeList.vue'
import AssetTypeForm from '@/components/finance/AssetTypeForm.vue'
import { mapState } from 'vuex'

export default {
  name: 'AssetType',
  components: {
    AssetTypeList,
    AssetTypeForm
  },
  mounted () {
    this.$store.dispatch('getAssetTypeList')
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getCompanyList')
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      asset: {
        id: null,
        name: null,
        account_asset: null,
        account_akumulasi: null,
        account_biaya_akumulasi: null,
        company_no: null
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  methods: {
    async backReload (id) {
      this.onClickEditFromList(id)
    },
    onClickNewFromList: function (value) {
      this.asset = {
        id: null,
        name: null,
        account_asset: null,
        account_akumulasi: null,
        account_biaya_akumulasi: null,
        company_no: this.authUser.company_no
      }
      this.listView = false
      this.formView = true
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.asset = value
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.asset = {
        id: null,
        name: null,
        account_asset: null,
        account_akumulasi: null,
        account_biaya_akumulasi: null,
        company_no: null
      }
      this.$refs.refreshList.refreshList()
    },
    onBack: function (value) {
      // console.log(value)
      this.$refs.refreshList.refreshList()
      this.onClickEditFromList(value)
    }
  }
}
</script>
